export { Text as Number } from '../Text'
